import React from 'react';
import { InputGroup, FormControl, Button } from 'react-bootstrap';
import { connect } from 'react-redux';
import { AnyType } from '../interfaces';

interface LocationSearchProps {
  onSearch?: (value: string | undefined) => void;
}

export const LocationSearch = (props: LocationSearchProps) => {
  const onSearch = (e: AnyType) => {
    e.preventDefault();
    const value = e.target.value;
    props.onSearch && props.onSearch(value);
  };

  return (
    <InputGroup>
      <InputGroup.Text className=' bg-transparent msg_search-icon'>
        <i className='fa-regular fa-magnifying-glass text-secondary'></i>
      </InputGroup.Text>
      <FormControl
        placeholder='Search Locations'
        onChange={onSearch}
        aria-label='Patient'
        aria-describedby='basic-addon1'
        className='search_input'
      />
    </InputGroup>
  );
};

const mapStateToProps = () => ({});

const mapDispatchToProps = {};

export const ConnectedLocationSearch = connect(mapStateToProps, mapDispatchToProps)(LocationSearch);
